import conversationInsightsImg from '~/assets/announcements/conversation-insights.png'
import billingRefreshImg from '~/assets/announcements/billing-refresh.png'
import webchatConfigRefreshImg from '~/assets/announcements/webchat-config-refresh.png'
import autoRechargeAddonsImg from '~/assets/announcements/auto-recharge-addons.png'
import webchatV34 from '~/assets/announcements/webchat-v3.4.png'
import webchatV35 from '~/assets/announcements/webchat-v3.5.png'
import free_trials_banner from '~/assets/announcements/free_trials_banner.png'
import { FileRouteTypes } from '~/routeTree.gen'

export type Announcement = {
  id: string
  asset: string
  title: string
  description: string
  releaseDate: string
  daysActive: number
  instructions?: string
  navigateTo: FileRouteTypes['to']
  navigateSearch?: Record<string, boolean>
  confirmLabel: string
  cancelLabel: string
}

export type AnnouncementId = (typeof ANNOUNCEMENTS)[number]['id']
export type AnnouncementsSearch = Extract<(typeof ANNOUNCEMENTS)[number], { navigateSearch: object }>['navigateSearch']

export const ANNOUNCEMENTS = [
  {
    id: 'conversation-insights',
    asset: conversationInsightsImg,
    title: 'Meet AI Insights',
    description:
      'Insights generates a title, a concise summary, and runs sentiment analysis on each conversation so you can have full visibility into the conversations your agent is having.',
    instructions: 'This feature consumes AI Spend.',
    releaseDate: '2025-11-03',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/conversations',
    navigateSearch: { aiInsights: true },
    confirmLabel: 'Enable',
    cancelLabel: 'Close',
  },
  {
    id: 'billing-refresh',
    asset: billingRefreshImg,
    title: 'Keep Track of Payments',
    description: 'Download invoices, manage add-ons, update AI Spend, and review payment details from a single place.',
    releaseDate: '2025-11-07',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/billing',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'webchat-config-refresh',
    asset: webchatConfigRefreshImg,
    title: 'Bring Your Brand to Every Chat',
    description:
      "Customize your agent's tone, personality, and Webchat's appearance to create conversations that look and feel naturally on-brand.",
    releaseDate: '2025-11-13',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity',
    confirmLabel: 'View',
    cancelLabel: 'Close',
  },
  {
    id: 'webchat-v3.4',
    asset: webchatV34,
    title: 'Webchat Improvements',
    description:
      'Smoother scrolling, the ability to paste images from your clipboard into chat, improved typing indicators, media rendering, performance, and reliability',
    instructions: 'Available in webchat v3.4',
    releaseDate: '2025-11-14',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings',
    confirmLabel: 'Go to Settings',
    cancelLabel: 'Close',
  },
  {
    id: 'auto-recharge-addons',
    asset: autoRechargeAddonsImg,
    title: 'Automatically purchase add-ons with Auto Recharge',
    description:
      'Never worry about interruptions. Auto Recharge automatically purchases Add-ons when you drop below a set usage threshold.',
    releaseDate: '2025-11-24',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/billing',
    confirmLabel: 'Enable Auto Recharge',
    cancelLabel: 'Close',
  },
  {
    id: 'webchat-v3.5',
    asset: webchatV35,
    title: 'Webchat Improvements',
    description:
      'Webchat input is now disabled while your bot processes a message. Upgrade to the latest version of Webchat to enable this behavior.',
    instructions: 'Available in Webchat v3.5',
    releaseDate: '2025-12-08',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings',
    confirmLabel: 'Go to Settings',
    cancelLabel: 'Close',
  },
  {
    id: 'free-trials',
    asset: free_trials_banner,
    title: 'Free Trials',
    description: 'Free trials of Plus and Team plans are now available to users without an existing subscription.',
    instructions: 'Terms and conditions apply.',
    releaseDate: '2026-02-04',
    daysActive: 30,
    navigateTo: '/workspaces/$workspaceId/billing',
    confirmLabel: 'Go to Billing',
    cancelLabel: 'Close',
  },
] as const
